import * as types from '../../mutation-types'
import {globalService} from '@/service/globalService'
import * as service from '@/service/httpService'
// initial state

const state = {
  allRolesData: []
}

// getters
const getters = {
  allRolesData: state => state.allRolesData
}

// actions
const actions = {
  // 加载领域数据
  loadAllRoles ({commit}) {
    service.roleService.loadAllRoles().then(
      function (response) {
        commit(types.SET_ALL_ROLES, response.data)
      },
      function (response) {
        globalService.showErrNofify(response)
      }
    )
  }
}

// mutations
const mutations = {
  [types.SET_ALL_ROLES] (state, allRolesData) {
    state.allRolesData = allRolesData
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/role-manage/role-manage.js